module.exports = __webpack_public_path__ + "img/CF_1P.5e3f692f.jpg";